import { API_URL } from '../../../app-config/constants';
import type NudgesRecordDto from '../../react/features/MeetingsDashboard/types/NudgesRecordDto';
import { get, post } from '../request';

getMeetingSpaces.operation = 'READ';
export function getMeetingSpaces() {
    return get<NudgesRecordDto[]>(`${API_URL}/meeting-nudges/spaces`);
}

interface MeetingSpaceNudgeRequest {
    participants: [string, string];
    nudgeeKey: string;
}

nudge.invalidates = ['getMeetingSpaces'];
export function nudge(request: MeetingSpaceNudgeRequest[]) {
    return post<NudgesRecordDto[]>(`${API_URL}/meeting-nudges/spaces`, {
        postData: request,
    });
}
